import React, { useState, useEffect } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import { useNavigate } from 'react-router-dom';
import { productService } from '../../service/productservice';

// Import your product images here (sample placeholders used)
import TitusSardine125g from "../../public/category-img/sauce/Sardines-Titus-125G_prev_ui.png";
import GeishaMackerelTomatoSauce150g from "../../public/category-img/sauce/GeishaMackerelTomatoSauce150g.jpg";
import HeinzSaladCream285g from "../../public/category-img/sauce/HeinzSaladCream285g.jpg";
import HeinzTomatoKetchupSauce1_25kg from "../../public/category-img/sauce/HeinzTomatoKetchupSauce1_25kg.jpg";
import HeinzMayonnaise940g from "../../public/category-img/sauce/HeinzMayonnaise940g.jpg";
import HeinzBurgerSauce220ml from "../../public/category-img/sauce/HeinzBurgerSauce220ml.jpg";
import ExeterCornedBeef12oz from "../../public/category-img/sauce/ExeterCornedBeef12oz.jpg";
import ShitoHotPepperSauce400ml from "../../public/category-img/sauce/ShitoHotPepperSauce400ml.png";
import TrofaiSpicyPalmnutPulp800g from "../../public/category-img/sauce/trofai-palm-nut-concentrate-800gr.jpg";
import HeinzSaladCream425g from "../../public/category-img/sauce/HeinzSaladCream425g.jpg";
import DivineShitoPepperSauce16oz from "../../public/category-img/sauce/ShitoHotPepperSauce400ml.png";
import HuntsTomatoesSauce8oz from "../../public/category-img/sauce/HuntTomatoesSauce8oz.jpg";
import HuntsTomatoesSauce15oz from "../../public/category-img/sauce/Hunt'sTomatoesSauce15oz.jpeg";

export const cannedproducts = [
  { id: 'CFS001', name: 'Titus Sardine 0.28 lb', brand: 'Titus', price: '$2.00', img: TitusSardine125g, description: 'Titus Sardine is a premium-quality canned fish packed in vegetable oil, offering a rich source of protein, omega-3 fatty acids, and essential nutrients. Known for its soft, flavorful texture, Titus Sardine enhances a variety of African dishes, such as Jollof rice, yam porridge, and sandwiches.' },
  { id: 'CFS002', name: 'Geisha Mackerel Tomato Sauce 0.33 lb', brand: 'Geisha', price: '$3.55', img: GeishaMackerelTomatoSauce150g, description: 'Geisha Mackerel in Tomato Sauce is a flavorful and nutritious canned seafood option, combining tender mackerel fillets with a rich, tangy tomato sauce. High in protein and omega-3 fatty acids, it supports heart health and overall well-being.' },
  { id: 'CFS003', name: 'Heinz Salad Cream 0.63 lb', brand: 'Heinz', price: '$6.95', img: HeinzSaladCream285g, description: 'Heinz Salad Cream is a tangy and creamy dressing made from a perfect blend of vinegar, eggs, and mustard, ideal for enhancing the flavor of salads, sandwiches, and coleslaws. Its smooth texture and unique taste also make it a versatile condiment.' },
  { id: 'CFS005', name: 'Heinz Tomato Ketchup Sauce 2.75 lb', brand: 'Heinz', price: '$6.71', img: HeinzTomatoKetchupSauce1_25kg, description: 'Heinz Tomato Ketchup Sauce is a classic condiment made from sun-ripened tomatoes and a perfect balance of spices, delivering a rich, tangy flavor. Ideal for pairing with fried yam, plantain, grilled meats, or snacks like meat pies and samosas.' },
  { id: 'CFS006', name: 'Heinz Mayonnaise 2.07 lb', brand: 'Heinz', price: '$1.96', img: HeinzMayonnaise940g, description: 'Heinz Mayonnaise is a rich and creamy condiment made with high-quality ingredients, offering a smooth and delightful flavor. Perfect for spreading on bread, mixing into salads, or creating dips, it enhances dishes like sandwiches, potato salad, and coleslaw.' },
  { id: 'CFS007', name: 'Heinz Burger Sauce 0.49 lb', brand: 'Heinz', price: '$23.15', img: HeinzBurgerSauce220ml, description: 'Heinz Burger Sauce is a flavorful and creamy condiment crafted to add a tangy and savory twist to your meals. Perfectly blended with pickles, mustard, and spices, it enhances the taste of burgers, sandwiches, and grilled meats.' },
  { id: 'CFS008', name: 'Exeter Corned Beef 0.75 lb', brand: 'Exeter', price: '$5.55', img: ExeterCornedBeef12oz, description: 'Exeter Corned Beef is a premium-quality canned meat made from carefully selected beef, offering a rich, savory flavor and tender texture. High in protein and versatile in use, it is perfect for creating quick and delicious meals.' },
  { id: 'CFS009', name: "Shito Hot Pepper Sauce 0.88 lb", brand: "African's Best", price: '$5.95', img: ShitoHotPepperSauce400ml, description: 'Shito Hot Pepper Sauce is a bold and flavorful Ghanaian condiment made from a blend of chili peppers, dried fish, shrimp, and aromatic spices. Its rich, smoky taste and spicy kick make it a perfect companion for rice dishes.' },
  { id: 'CFS010', name: 'Trofai Spicy Palmnut Pulp 1.76 lb', brand: 'Trofai', price: '$6.95', img: TrofaiSpicyPalmnutPulp800g, description: 'Trofai Spicy Palm Nut Pulp is a rich and flavorful base made from high-quality palm fruit, enhanced with a spicy kick for authentic African cooking. Ideal for preparing dishes like Banga soup, palm nut stew, or assorted vegetable soups.' },
  { id: 'CFS011', name: 'Heinz Salad Cream 0.94 lb', brand: 'Heinz', price: '$6.95', img: HeinzSaladCream425g, description: 'Heinz Salad Cream is a tangy and creamy dressing made from a perfect blend of vinegar, eggs, and mustard, ideal for enhancing the flavor of salads, sandwiches, and coleslaws. Its smooth texture and unique taste also make it a versatile condiment.' },
  { id: 'CFS012', name: 'Divine Shito Pepper Sauce 1 lb', brand: 'Divine Shito', price: '$16.95', img: DivineShitoPepperSauce16oz, description: 'Shito Hot Pepper Sauce is a bold and flavorful Ghanaian condiment made from a blend of chili peppers, dried fish, shrimp, and aromatic spices. Its rich, smoky taste and spicy kick make it a perfect companion for rice dishes.' },
  { id: 'CFS013', name: "Hunt's Tomatoes Sauce 0.5 lb", brand: "Hunt's", price: '$0.95', img: HuntsTomatoesSauce8oz, description: "Hunt's Tomato Sauce is a smooth and rich sauce made from vine-ripened tomatoes, perfect for adding depth and flavor to your favorite dishes. Ideal for preparing stews, Jollof rice, and pasta sauces, it blends seamlessly into recipes." },
  { id: 'CFS014', name: "Hunt's Tomatoes Sauce 0.94 lb", brand: "Hunt's", price: '$1.85', img: HuntsTomatoesSauce15oz, description: "Hunt's Tomato Sauce is a smooth and rich sauce made from vine-ripened tomatoes, perfect for adding depth and flavor to your favorite dishes. Ideal for preparing stews, Jollof rice, and pasta sauces, it blends seamlessly into recipes." }
];

const ProductCard = ({ product, updateCartCount, forceUpdateKey }) => {
  const [inCart, setInCart] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const foundItem = storedCartItems.find((item) => item.id === product.id);
    if (foundItem) {
      setInCart(true);
      setQuantity(foundItem.quantity);
    } else {
      setInCart(false);
      setQuantity(0);
    }
  }, [product.id, forceUpdateKey]);

  const handleAddToCart = () => {
    if (!inCart) {
      setInCart(true);
      setQuantity(1);
      saveToLocalStorage(product, 1);
      updateCartCount();
    }
  };

  const handleProductClick = () => {
    navigate(`/product/${product.name}`);
  };

  const saveToLocalStorage = (product, quantity) => {
    const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const updatedCart = [...cartItems, { ...product, quantity }];
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-3 w-full flex flex-col justify-between">
      <div onClick={handleProductClick} className="relative cursor-pointer flex justify-center items-center">
        <img
          src={product.img}
          alt={product.name}
          className={`h-60 w-full object-cover rounded-lg ${product.quantity === 0 ? 'opacity-50' : ''}`}
        />
        {product.quantity === 0 && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-lg">
            <span className="text-white text-lg font-semibold">Out of Stock</span>
          </div>
        )}
      </div>
      <div className="mt-4">
        <h3 className="text-lg font-semibold">{product.name}</h3>
        <p className="text-[#007D44]">{product.brand}</p>
        <p className="text-[#007D44] font-bold mt-2">${product.price}</p>
      </div>
      {inCart ? (
        <div className="mt-4 flex items-center justify-between border bg-slate-100 shadow-md rounded-full">
          <button
            onClick={() => {
              if (quantity > 1) {
                setQuantity((prevQuantity) => prevQuantity - 1);
                updateCartCount();
              }
            }}
            className="bg-[#38c13a] text-white py-2 px-4 rounded-lg hover:bg-[#2e9830]"
          >
            -
          </button>
          <span className="text-lg font-semibold">{quantity}</span>
          <button
            onClick={() => {
              setQuantity((prevQuantity) => prevQuantity + 1);
              updateCartCount();
            }}
            className="bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44]"
          >
            +
          </button>
        </div>
      ) : (
        <button
          onClick={handleAddToCart}
          className={`mt-4 bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44] ${
            product.quantity === 0 ? 'cursor-not-allowed opacity-50' : ''
          }`}
          disabled={product.quantity === 0}
        >
          Add to cart
        </button>
      )}
    </div>
  );
};


const CannedCategory = () => {
  const [cartCount, setCartCount] = useState(0);
  const [forceUpdateKey, setForceUpdateKey] = useState(0);


  const [uploadStatus, setUploadStatus] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [cloudinaryUrls, setCloudinaryUrls] = useState({});
  const [products, setProducts] = useState([]);
  const [hasIncompatibleItems, setHasIncompatibleItems] = useState(false); // New state
      

 // Auto-upload products when component mounts
 useEffect(() => {
  const uploadProducts = async () => {
    try {
      setIsUploading(true);

      // Prepare products for upload
      const productsToUpload = cannedproducts.map(product => ({
        ...product,
        id: product.id,
        name: product.name,
        brand: product.brand,
        description: product.description,
        category: 'cannedproducts',
        quantity: 0,
        price: parseFloat(product.price.replace('$', ''))
      }));

      try {
        const result = await productService.bulkCreateProducts(productsToUpload);
        
        setUploadStatus({
          success: true,
          message: `${result.created} beauty products uploaded successfully`
        });
      } catch (error) {
        setUploadStatus({
          success: false,
          message: error.response?.data?.message || 'Product upload failed'
        });
      }
    } catch (error) {
      console.error('Error uploading products:', error);
      setUploadStatus({
        success: false,
        message: 'Failed to upload products'
      });
    } finally {
      setIsUploading(false);
    }
  };


  // Fetch products by category
  const fetchProducts = async () => {
    try {
      const result = await productService.getProductsByCategory('cannedproducts');
      
      // If no products exist, trigger upload
      if (result.count === 0) {
        await uploadProducts();
      } else {
        setProducts(result.products);
        console.log(result.products)
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  fetchProducts();
}, []);

 

 useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    
    // Check for incompatible items on initial load
    const hasIncompatible = storedCartItems.some(item => 
      ["Large Box", "Small Box", "Discount"].includes(item.orderType)
    );
    setHasIncompatibleItems(hasIncompatible);

  }, []);

  const updateCartCount = () => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    
    // Check for incompatible items whenever cart updates
    const hasIncompatible = storedCartItems.some(item => 
      ["Large Box", "Small Box", "Discount"].includes(item.orderType)
    );
    setHasIncompatibleItems(hasIncompatible);
  };

  const forceUpdateProducts = () => {
    setForceUpdateKey(prevKey => prevKey + 1); // This will force a re-render in ProductCard
  };

  return (
    <>
      <Navbar cartCount={cartCount} updateCartCount={updateCartCount} forceUpdateProducts={forceUpdateProducts} /> {/* Pass cart count to Navbar */}

      {/* Upload Status Notification */}
      {isUploading && (
        <div className="fixed top-0 left-0 w-full bg-yellow-500 text-white text-center py-2 z-50">
          Uploading sponge products...
        </div>
      )}
      
      {uploadStatus && (
        <div 
          className={`
            fixed 
            top-0 
            left-0 
            w-full 
            text-center 
            py-2 
            z-50 
            ${uploadStatus.success ? 'bg-green-500' : 'bg-red-500'} 
            text-white
          `}
        >
          {uploadStatus.message}
        </div>
      )}

      <div className="min-h-screen p-8 max-sm:p-1 lg:mt-[70px] mt-[130px]">
      {hasIncompatibleItems && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">
            Your cart contains items from a different box type. Please complete your current order 
            or clear the cart before selecting individual sponge products.
          </span>
          <button
            onClick={() => setHasIncompatibleItems(false)}
            className="absolute top-0 right-0 px-2 py-1"
          >
            ×
          </button>
        </div>
      )}
        <div className="flex justify-between items-center max-sm:flex-col max-sm:items-start mb-6">
          <h3 className="text-2xl font-semibold">Canned Products</h3>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6">
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              updateCartCount={updateCartCount}
              forceUpdateKey={forceUpdateKey} // Pass updateCartCount to ProductCard
            />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CannedCategory;